import { initEnvValue } from '../../../packages/src/envs/index.js';

// Envs
initEnvValue('NODE_ENV', process.env.NODE_ENV);
initEnvValue('PHOTO_ALBUM_URL', process.env.PHOTO_ALBUM_URL);
initEnvValue('BACKEND_API', process.env.BACKEND_API);
initEnvValue('POOL_DATA_USER_ID', process.env.POOL_DATA_USER_ID);
initEnvValue('POOL_DATA_CLIENT_ID', process.env.POOL_DATA_CLIENT_ID);
initEnvValue('TOTP_ISSUER', process.env.TOTP_ISSUER);
initEnvValue('TOTP_DISABLED_USERS', process.env.TOTP_DISABLED_USERS);
initEnvValue('IMG_PATH', process.env.IMG_PATH);
initEnvValue('ASSET_PATH', process.env.ASSET_PATH);
initEnvValue('DEBUG_MODE', process.env.DEBUG_MODE, false);
initEnvValue('SENTRY_ENV', process.env.SENTRY_ENV, process.env.BITBUCKET_COMMIT !== undefined);
